"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdApollo = require("cccisd-apollo");
var _entityProgress = _interopRequireDefault(require("./entityProgress.graphql"));
var _index = require("../../../ModalContents/WithModules/WithModulesForm/Pinned/PinnedContentSection/Form/TopLevelEntityTable/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
var flowKeysToOmit = ['flowSettings', 'isComplete', 'isStarted', 'lastVisited', 'progressBarGroup', 'showIfOption', 'surveySettings'];
var _default = exports["default"] = function _default(_ref) {
  var actingPawnId = _ref.actingPawnId,
    allowRetake = _ref.allowRetake,
    deploymentId = _ref.deploymentId,
    isPreviewMode = _ref.isPreviewMode,
    language = _ref.language,
    flowList = _ref.flowList,
    mustTakeInOrder = _ref.mustTakeInOrder,
    mediatorProps = _ref.mediatorProps,
    onAlreadyComplete = _ref.onAlreadyComplete,
    onAssignmentComplete = _ref.onAssignmentComplete,
    onModuleComplete = _ref.onModuleComplete,
    onComplete = _ref.onComplete,
    onFlowComplete = _ref.onFlowComplete,
    onFlowStarted = _ref.onFlowStarted;
  var _useState = (0, _react.useState)(flowList.filter(function (item) {
      return item.isComplete;
    }).map(function (item) {
      return item.handle;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    completedFlows = _useState2[0],
    setCompletedFlows = _useState2[1];
  var _useState3 = (0, _react.useState)(!flowList.filter(function (f) {
      return f.isRequired;
    }).find(function (f) {
      return !f.isComplete;
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    hasCompleted = _useState4[0],
    setHasCompleted = _useState4[1];
  var _useState5 = (0, _react.useState)(flowList.filter(function (item) {
      return item.isStarted;
    }).map(function (item) {
      return item.handle;
    })),
    _useState6 = _slicedToArray(_useState5, 2),
    startedFlows = _useState6[0],
    setStartedFlows = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    nextFlowHandle = _useState8[0],
    setNextFlowHandle = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    orderedFlowHandles = _useState0[0],
    setOrderedFlowHandles = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    currentFlowHandle = _useState10[0],
    setCurrentFlowHandle = _useState10[1];
  var currentFlowFromFlowList = flowList.find(function (item) {
    return item.handle === currentFlowHandle;
  });
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isLoading = _useState12[0],
    setIsLoading = _useState12[1];
  var _useState13 = (0, _react.useState)(mediatorProps.modules.filter(function (m) {
      return m.language === language;
    })),
    _useState14 = _slicedToArray(_useState13, 2),
    modules = _useState14[0],
    setModules = _useState14[1];
  var _useState15 = (0, _react.useState)(0),
    _useState16 = _slicedToArray(_useState15, 2),
    initialEntityId = _useState16[0],
    setInitialEntityId = _useState16[1];
  var _useState17 = (0, _react.useState)((0, _get2["default"])(mediatorProps, 'pinnedContent', {})),
    _useState18 = _slicedToArray(_useState17, 2),
    pinnedContentMap = _useState18[0],
    setPinnedContentMap = _useState18[1];
  var _useState19 = (0, _react.useState)(modules.reduce(function (allEntityIds, currMod) {
      if (currMod.unlockAfter === 'entity' && ['hidden', 'disabled'].includes(currMod.visibility)) {
        allEntityIds.push(currMod[_index.fieldMap[language]]);
      }
      return allEntityIds;
    }, [])),
    _useState20 = _slicedToArray(_useState19, 2),
    entityIdsToCheckProgress = _useState20[0],
    setEntityIdsToCheckProgress = _useState20[1];
  var _useState21 = (0, _react.useState)(null),
    _useState22 = _slicedToArray(_useState21, 2),
    entityCompletionMap = _useState22[0],
    setEntityCompletionMap = _useState22[1];

  // keep track of lastVisited locally so we don't have to refetch progress every single time
  var initialLastVisitedLocal = {};
  flowList.forEach(function (f) {
    initialLastVisitedLocal[f.handle] = f.lastVisited;
  });
  var _useState23 = (0, _react.useState)(initialLastVisitedLocal),
    _useState24 = _slicedToArray(_useState23, 2),
    lastVisitedLocal = _useState24[0],
    setLastVisitedLocal = _useState24[1];
  var navItems = flowList.map(function (flow) {
    var isAllowed = !mustTakeInOrder;
    var isCompleted = completedFlows.includes(flow.handle);
    var isStarted = startedFlows.includes(flow.handle);
    var isResume = !isCompleted && isStarted;
    if (isCompleted || isStarted || flow.handle === nextFlowHandle || flowList.filter(function (f) {
      return f.ordinalPosition < flow.ordinalPosition;
    }).every(function (f) {
      return !f.isRequired || completedFlows.includes(f.handle);
    })) {
      isAllowed = true;
    }
    return _objectSpread(_objectSpread({}, (0, _omit2["default"])(flow, flowKeysToOmit)), {}, {
      title: (0, _get2["default"])(flow, 'flowSettings.playerTemplateSettings.title'),
      isCompleted: isCompleted,
      isAllowed: isAllowed,
      isResume: isResume,
      lastVisited: lastVisitedLocal[flow.handle],
      setCurrent: !isAllowed ? null : function () {
        // before switching, set lastVisited on current flow
        if (currentFlowHandle) {
          setLastVisitedLocal(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, currentFlowHandle, new Date()));
          });
        }
        setCurrentFlowHandle(flow.handle);
        setStartedFlows((0, _union2["default"])(startedFlows, [flow.handle]).sort());
      }
    });
  });
  var surveyCompletionMap = flowList.reduce(function (all, flow) {
    if (flow.isComplete || completedFlows.includes(flow.handle)) {
      all[flow.handle] = true;
    }
    return all;
  }, {});
  var moduleCompletionMap = modules.reduce(function (allProgress, mod) {
    if (mod.isAllLessonsComplete) {
      allProgress[mod.id] = true;
    }
    return allProgress;
  }, {});
  (0, _react.useEffect)(function () {
    function getPinnedContentData() {
      return _getPinnedContentData.apply(this, arguments);
    }
    function _getPinnedContentData() {
      _getPinnedContentData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var resourceIds, entityIds, tallyResourceIdsAndEntityIds, updatedPinnedContent, resourceResponse, resourceData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              tallyResourceIdsAndEntityIds = function _tallyResourceIdsAndE(pinnedContent, path) {
                if (pinnedContent.type === 'resource' && pinnedContent.resourceId) {
                  if (!Array.isArray(resourceIds[pinnedContent.resourceId])) {
                    resourceIds[pinnedContent.resourceId] = [];
                  }
                  resourceIds[pinnedContent.resourceId].push(path);
                }
                if (pinnedContent.visibility !== 'always' && pinnedContent.unlockAfter === 'entity') {
                  if (language === 'es' && pinnedContent.entityIdEs) {
                    if (!Array.isArray(entityIds[pinnedContent.entityIdEs])) {
                      entityIds[pinnedContent.entityIdEs] = [];
                    }
                    entityIds[pinnedContent.entityIdEs].push(path);
                  }
                  if (language === 'en' && pinnedContent.entityIdEn) {
                    if (!Array.isArray(entityIds[pinnedContent.entityIdEn])) {
                      entityIds[pinnedContent.entityIdEn] = [];
                    }
                    entityIds[pinnedContent.entityIdEn].push(path);
                  }
                }
              };
              // mapping from ID to paths in pinnedContent
              resourceIds = {};
              entityIds = {};
              Object.keys(pinnedContentMap).forEach(function (topLevelKey) {
                // top-level
                if (topLevelKey === 'topLevel') {
                  if (Array.isArray(pinnedContentMap[topLevelKey])) {
                    pinnedContentMap[topLevelKey].forEach(function (c, i) {
                      return tallyResourceIdsAndEntityIds(c, "topLevel.".concat(i));
                    });
                  }
                  return;
                }

                // both module-level and lesson-level
                if (_typeof(pinnedContentMap[topLevelKey]) === 'object') {
                  Object.keys(pinnedContentMap[topLevelKey]).forEach(function (moduleKey) {
                    if (Array.isArray(pinnedContentMap[topLevelKey][moduleKey])) {
                      pinnedContentMap[topLevelKey][moduleKey].forEach(function (c, j) {
                        return tallyResourceIdsAndEntityIds(c, "".concat(topLevelKey, ".").concat(moduleKey, ".").concat(j));
                      });
                    }
                  });
                }
              });
              if (!(Object.keys(resourceIds).length <= 0 && Object.keys(entityIds).length <= 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              updatedPinnedContent = (0, _cloneDeep2["default"])(pinnedContentMap);
              if (!(Object.keys(resourceIds).length > 0)) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return _cccisdAxios["default"].get(Boilerplate.route('api.resources.resource.index'), {
                params: {
                  ids: Object.keys(resourceIds)
                }
              });
            case 2:
              resourceResponse = _context.v;
              resourceData = (0, _get2["default"])(resourceResponse, 'data.data', []) || [];
              resourceData.forEach(function (resource) {
                if (resourceIds[resource.id] && Array.isArray(resourceIds[resource.id])) {
                  resourceIds[resource.id].forEach(function (path) {
                    var existing = (0, _get2["default"])(updatedPinnedContent, path, {});
                    (0, _set2["default"])(updatedPinnedContent, path, _objectSpread(_objectSpread({}, existing), {}, {
                      resource: resource
                    }));
                  });
                }
              });
            case 3:
              if (Object.keys(entityIds).length > 0) {
                setEntityIdsToCheckProgress(function (prev) {
                  return [].concat(_toConsumableArray(prev), _toConsumableArray(Object.keys(entityIds)));
                });
              }
              setPinnedContentMap(updatedPinnedContent);
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _getPinnedContentData.apply(this, arguments);
    }
    getPinnedContentData();
  }, []);
  (0, _react.useEffect)(function () {
    if (!allowRetake && flowList.every(function (item) {
      return item.isComplete;
    }) && onAlreadyComplete) {
      onAlreadyComplete();
    }
    function packageModules() {
      var packagedModules = [];
      modules.sort(function (a, b) {
        return a.id - b.id;
      });
      modules.forEach(function (module, i) {
        // new JSON structure has `surveyHandles` on modules in assignment settings
        // old JSON structure has `moduleId` key on survey settings
        if (module.surveyHandles) {
          module.lessons = getLessonsByModuleConfig(module);
        } else {
          module.lessons = getLessonsByModuleId(module.id);
        }
        module.setActive = setActiveModuleFunc(module);

        // isComplete used to determine if module is passed; isAllLessonsComplete used for checkmark
        module.isComplete = module.lessons.every(function (item) {
          return !item.isRequired || completedFlows.includes(item.handle);
        });
        module.isAllLessonsComplete = module.lessons.every(function (item) {
          return completedFlows.includes(item.handle);
        });
        module.isResume = !module.isComplete && module.lessons.some(function (item) {
          return startedFlows.includes(item.handle);
        });

        // will change isAllowed after all modules are packaged
        module.isAllowed = false;
        module.isEmpty = module.lessons.length === 0;
        module.showDimmed = !module.isResume && !module.isComplete || module.isEmpty;
        addPinnedContent(module);
        packagedModules.push(module);
      });
      setModules(packagedModules);
      var ofh = [];
      packagedModules.forEach(function (module) {
        ofh = ofh.concat((0, _map2["default"])(module.lessons, 'handle'));
      });
      setOrderedFlowHandles(ofh);
      checkNextFlowHandle(ofh);
    }
    packageModules();
  }, []);
  (0, _react.useEffect)(function () {
    function updateModules() {
      // wait until all data is fetched
      if (!pinnedContentMap || !entityCompletionMap) {
        return;
      }
      var packagedModules = [];
      modules.sort(function (a, b) {
        return a.id - b.id;
      });
      modules.forEach(function (module, i) {
        if (module.surveyHandles) {
          module.lessons = getLessonsByModuleConfig(module);
        } else {
          module.lessons = getLessonsByModuleId(module.id);
        }
        module.isComplete = module.lessons.every(function (item) {
          return !item.isRequired || completedFlows.includes(item.handle);
        });
        module.isAllLessonsComplete = module.lessons.every(function (item) {
          return completedFlows.includes(item.handle);
        });
        module.isResume = !module.isComplete && module.lessons.some(function (item) {
          return startedFlows.includes(item.handle);
        });
        addPinnedContent(module);
        packagedModules.push(module);
      });

      // isAllowed and showDimmed must be calculated after all other modules because they can rely on completion of ALL moodules or not
      packagedModules.forEach(function (packagedModule, i) {
        if (mustTakeInOrder) {
          packagedModule.isAllowed = i === 0 ? true : !packagedModules.some(function (m) {
            return m.id < packagedModule.id && !m.isComplete;
          });
        } else if (['hidden', 'disabled'].includes(packagedModule.visibility) && !!packagedModule.unlockAfter) {
          // cases of unlockAfter: 'all', 'allRequired', 'module_X', 'survey_X', 'entity'
          if (packagedModule.unlockAfter === 'all') {
            packagedModule.isAllowed = packagedModules.every(function (m) {
              return m.id === packagedModule.id || m.isComplete;
            });
          } else if (packagedModule.unlockAfter === 'allRequired') {
            var thisModuleFlowHandles = packagedModule.lessons.reduce(function (all, currLess) {
              all[currLess.flowHandle] = true;
              return all;
            }, {});
            packagedModule.isAllowed = !flowList.every(function (f) {
              return f.isRequired && !f.isComplete && !thisModuleFlowHandles[f.flowHandle];
            });
          } else if (packagedModule.unlockAfter === 'entity') {
            var entityId = (0, _get2["default"])(packagedModule, _index.fieldMap[language], -1);
            packagedModule.isAllowed = entityId in entityCompletionMap && entityCompletionMap[entityId];
          } else if (/^module_[0-9]{1,}$/.test(packagedModule.unlockAfter)) {
            var moduleId = parseInt(packagedModule.unlockAfter.replace(/^module_/, ''), 10);
            packagedModule.isAllowed = !Number.isNaN(moduleId) && moduleId in moduleCompletionMap && moduleCompletionMap[moduleId];
          } else if (/^survey_/.test(packagedModule.unlockAfter)) {
            var surveyHandle = packagedModule.unlockAfter.replace(/^survey_/, '');
            packagedModule.isAllowed = surveyHandle in surveyCompletionMap && surveyCompletionMap[surveyHandle];
          } else {
            packagedModule.isAllowed = true;
          }
        } else {
          packagedModule.isAllowed = true;
        }
        packagedModule.showDimmed = !packagedModule.isAllowed || packagedModule.lessons.length === 0;
      });
      var hasActive = packagedModules.some(function (m) {
        return m.isActive;
      });
      if (!hasActive) {
        for (var i = 0; i < packagedModules.length; i++) {
          if (!packagedModules[i].isAllowed) {
            continue;
          }
          if (packagedModules[i].lessons.some(function (les) {
            return !les.isCompleted;
          })) {
            packagedModules[i].isActive = true;
            hasActive = true;
            break;
          }
        }
      }

      // if all completed, start the user back on first module
      if (!hasActive) {
        packagedModules[0].isActive = true;
      }
      setModules(packagedModules);
    }
    checkNextFlowHandle(orderedFlowHandles);
    updateModules();
  }, [startedFlows, completedFlows, lastVisitedLocal, nextFlowHandle, pinnedContentMap, entityCompletionMap]);
  (0, _react.useEffect)(function () {
    function checkFlowStarted() {
      return _checkFlowStarted.apply(this, arguments);
    }
    function _checkFlowStarted() {
      _checkFlowStarted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (currentFlowFromFlowList) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              setIsLoading(true);
              _context2.n = 2;
              return onFlowStarted(currentFlowFromFlowList);
            case 2:
              setIsLoading(false);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return _checkFlowStarted.apply(this, arguments);
    }
    checkFlowStarted();
  }, [currentFlowHandle]);
  (0, _react.useEffect)(function () {
    checkEntityProgress();
  }, [entityIdsToCheckProgress]);
  function checkEntityProgress() {
    return _checkEntityProgress.apply(this, arguments);
  }
  function _checkEntityProgress() {
    _checkEntityProgress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var response, entityProgress, entityCompletion;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (!(!Array.isArray(entityIdsToCheckProgress) || !entityIdsToCheckProgress.length)) {
              _context3.n = 1;
              break;
            }
            setEntityCompletionMap({});
            return _context3.a(2);
          case 1:
            if (!isPreviewMode) {
              _context3.n = 2;
              break;
            }
            setEntityCompletionMap(entityIdsToCheckProgress.reduce(function (all, curr) {
              all[curr] = true;
              return all;
            }, {}));
            return _context3.a(2);
          case 2:
            _context3.n = 3;
            return _cccisdApollo.client.query({
              query: _entityProgress["default"],
              variables: {
                pawnId: actingPawnId,
                entityIds: entityIdsToCheckProgress,
                deploymentIds: [deploymentId]
              },
              fetchPolicy: 'network-only'
            });
          case 3:
            response = _context3.v;
            entityProgress = (0, _get2["default"])(response, 'data.flows.entityStateList', []) || [];
            entityCompletion = entityProgress.reduce(function (all, ent) {
              if (ent.completedLastDate) {
                all[ent.entityId] = true;
              }
              return all;
            }, {});
            setEntityCompletionMap(entityCompletion);
          case 4:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _checkEntityProgress.apply(this, arguments);
  }
  function addPinnedContent(module) {
    // subtract 1 because pinnedContent is index-based, not id-based
    module.pinnedContent = (0, _get2["default"])(pinnedContentMap, "".concat(module.id - 1, ".topLevel"), []) || [];
    module.lessons.forEach(function (lesson) {
      lesson.pinnedContent = (0, _get2["default"])(pinnedContentMap, "".concat(module.id - 1, ".").concat(lesson.handle), []) || [];
    });
  }

  /**
   * If applicable, set the next flow handle.
   *
   * @param Array ofh The orderedFlowHandles array to consider
   */
  function checkNextFlowHandle(ofh) {
    if (startedFlows.length !== completedFlows.length || startedFlows.length === ofh.length) {
      return;
    }
    if (startedFlows.every(function (sf) {
      return completedFlows.some(function (cf) {
        return cf.handle === sf.handle;
      });
    })) {
      var determinedNextHandle = (0, _difference2["default"])(ofh, startedFlows)[0];
      if (determinedNextHandle !== nextFlowHandle) {
        setNextFlowHandle(determinedNextHandle);
      }
    }
  }
  function setActiveModuleFunc(module) {
    return function () {
      setModules(modules.map(function (m) {
        m.isActive = m.id === module.id;
        return m;
      }));
    };
  }
  function setCurrentFlowAndEntity(surveyHandle, entityId) {
    setInitialEntityId(entityId);

    /* Can't rely on currentModule here
     * It can be triggered from Module A even if survey/entity is in Module B
     */
    var nextCurrModule;
    var nextCurrLesson;
    for (var i = 0; i < modules.length; i++) {
      if (nextCurrModule && nextCurrLesson) {
        break;
      }
      var m = modules[i];
      for (var j = 0; j < m.lessons.length; j++) {
        var l = m.lessons[j];
        if (l.handle === surveyHandle) {
          nextCurrModule = m;
          nextCurrLesson = l;
          break;
        }
      }
    }
    setActiveModuleFunc(nextCurrModule)();
    nextCurrLesson.setCurrent();
  }
  function getLessonsByModuleId(moduleId) {
    var lessons = [];
    navItems.forEach(function (f) {
      if (Number.parseInt(f.moduleId, 10) === Number.parseInt(moduleId, 10)) {
        lessons.push(f);
      }
    });
    return (0, _sortBy2["default"])(lessons, 'ordinalPosition');
  }
  function getLessonsByModuleConfig(module) {
    return module.surveyHandles.reduce(function (total, currentSurveyHandle) {
      var flowMatch = navItems.find(function (f) {
        return f.handle === currentSurveyHandle && f.language === language;
      });
      return flowMatch ? [].concat(_toConsumableArray(total), [flowMatch]) : total;
    }, []);
  }
  function getCurrentFlowProps() {
    if (!currentFlowHandle) {
      return null;
    }
    var currentFlowIndex = navItems.findIndex(function (item) {
      return item.handle === currentFlowHandle;
    });
    var currentFlow = navItems[currentFlowIndex];
    return _objectSpread(_objectSpread(_objectSpread({}, (0, _omit2["default"])(currentFlow, flowKeysToOmit)), currentFlow.isCompleted && {
      pageFirstElementId: 0
    }), {}, {
      onComplete: function onComplete() {
        completeCurrentFlow();
      }
    });
  }
  function completeCurrentFlow() {
    return _completeCurrentFlow.apply(this, arguments);
  }
  function _completeCurrentFlow() {
    _completeCurrentFlow = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var currModule, isFirstCompletion, updatedCompletedFlows, requiredFlows;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            setIsLoading(true);
            currModule = modules.length === 1 && modules[0].lessons ? modules[0] : modules.find(function (item) {
              return item.isActive;
            });
            isFirstCompletion = currentFlowFromFlowList.isComplete === false;
            _context4.n = 1;
            return onFlowComplete(currentFlowFromFlowList, {
              isFirstCompletion: isFirstCompletion,
              moduleId: currModule.id
            });
          case 1:
            updatedCompletedFlows = (0, _union2["default"])(completedFlows, [currentFlowHandle]);
            requiredFlows = flowList.filter(function (item) {
              return item.isRequired;
            });
            if (!(!hasCompleted && requiredFlows.every(function (item) {
              return updatedCompletedFlows.includes(item.handle);
            }))) {
              _context4.n = 3;
              break;
            }
            if (!onAssignmentComplete) {
              _context4.n = 2;
              break;
            }
            _context4.n = 2;
            return onAssignmentComplete();
          case 2:
            setHasCompleted(true);
          case 3:
            if (!(updatedCompletedFlows.length === flowList.length && onComplete)) {
              _context4.n = 4;
              break;
            }
            _context4.n = 4;
            return onComplete();
          case 4:
            if (!(!currModule.isComplete && currModule.lessons.every(function (item) {
              return !item.isRequired || updatedCompletedFlows.includes(item.handle);
            }))) {
              _context4.n = 6;
              break;
            }
            if (!onModuleComplete) {
              _context4.n = 5;
              break;
            }
            _context4.n = 5;
            return onModuleComplete({
              moduleId: currModule.id,
              isFirstCompletion: isFirstCompletion
            });
          case 5:
            currModule.isComplete = true;
          case 6:
            setLastVisitedLocal(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, currentFlowHandle, new Date()));
            });
            setCompletedFlows(updatedCompletedFlows.sort());
            setCurrentFlowHandle(null);
            setInitialEntityId(0);
            checkEntityProgress();
            setIsLoading(false);
          case 7:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _completeCurrentFlow.apply(this, arguments);
  }
  return {
    closeFlowPlayer: function closeFlowPlayer() {
      setLastVisitedLocal(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, currentFlowHandle, new Date()));
      });
      setCurrentFlowHandle(null);
      setInitialEntityId(0);
      checkEntityProgress();
    },
    currentFlowProps: getCurrentFlowProps(),
    entityCompletionMap: entityCompletionMap || {},
    initialEntityId: initialEntityId,
    isAllComplete: completedFlows.length === flowList.length,
    isAllRequiredComplete: hasCompleted,
    isLoading: isLoading,
    modules: modules.filter(function (m) {
      return mustTakeInOrder || m.isAllowed || m.visibility !== 'hidden';
    }),
    moduleCompletionMap: moduleCompletionMap,
    pinnedContentMap: pinnedContentMap,
    setCurrentFlowAndEntity: setCurrentFlowAndEntity,
    surveyCompletionMap: surveyCompletionMap
  };
};